import { HOMEPAGE_GPT_ID } from '@/components-page/homepage/advertisement/homepageAdSlots'
import { StyledGptMasthead } from '@/components-page/homepage/advertisement/styled'

export const GptMasthead = () => {
  return <StyledGptMasthead id={HOMEPAGE_GPT_ID.MASTHEAD} data-testid={HOMEPAGE_GPT_ID.MASTHEAD} />
}
